import { useEffect } from 'react';

interface useHashChangeProps {
    callback: (hash: string) => void;
    removeHashAfterCallback?: boolean;
}

export const useHashChange = ({ callback, removeHashAfterCallback = true }: useHashChangeProps) => {
    useEffect(() => {
        const handleHashChange = () => {
            const currentHash = window.location.hash;
            callback(currentHash);

            if (removeHashAfterCallback) {
                window.location.hash = '';
            }
        };
        window.addEventListener('hashchange', handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [callback, removeHashAfterCallback]);
};
